import {attachMessages} from "../../components/survey/messages";
import attachAdvancedSettings from "../../components/survey/attach-advanced-settings";
import execute_on from "../../libs/execute-on";
import {attachFroalaEditor} from "../../plugins/froala-editor";

execute_on('survey.closing.edit', function () {
    attachMessages($('#final-messages'));
    attachMessages($('#quota-full-messages'));
    attachMessages($('#screen-out-messages'));
    attachAdvancedSettings();
    attachFroalaEditor();
});
